module.exports = __webpack_public_path__ + "img/health_status_icon3.f768a4e9.png";